export const PACKAGE_NAME = 'jiraRouterResourcesServicedeskProjectSummary';
export const TEAM_NAME = 'jsd-shield';

export const REQUEST_TYPE_FILTER = 'request type';
export const SERVICE_DESK_ORIGIN_FILTER = 'service desk origin';
export const SERVICE_DESK_ORIGIN_DUPLICATE_FILTER = 'cf[10010]';
